import styled from 'styled-components';
import { colors } from 'constants/colors';
import { selectedClassName } from 'components/PaymentSwitcher/constants';

const scale = 0.7;

const SWITCHER_WIDTH = 200 * scale;
const SWITCHER_SIZE = 80 * scale;
const SWITCHER_HANDLE_SIZE = 60 * scale;
const SWITCHER_HANDLE_MARGIN = (SWITCHER_SIZE - SWITCHER_HANDLE_SIZE) / 2;

export const StyledSwitchHandle = styled.div`
  position: absolute;
  background-color: ${colors.orange};
  width: ${SWITCHER_HANDLE_SIZE}px;
  height: ${SWITCHER_HANDLE_SIZE}px;
  margin: ${SWITCHER_HANDLE_MARGIN}px;
  border-radius: 50%;
  left: 0;
  transition: left 0.2s;
`;

export const StyledSwitcher = styled.div`
  background-color: ${colors.white};
  width: ${SWITCHER_WIDTH}px;
  height: ${SWITCHER_SIZE}px;
  border-radius: ${SWITCHER_SIZE / 2}px;
  margin: 0 18px;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s;
  transform: perspective(900px) scale(0.5) ;

  ${(props) =>
    props.enabled && `${StyledSwitchHandle} {left: ${SWITCHER_WIDTH - SWITCHER_SIZE}px}`};
`;

export const StyledSwitchOption = styled.div`
  position: absolute;
  white-space: nowrap;
  height: ${SWITCHER_SIZE}px;
  line-height: ${SWITCHER_SIZE}px;
  top: 0;
  color: ${colors.white}
  user-select: none;
  
  .${selectedClassName} {
    color: ${colors.black};
    background-color: ${colors.rose};
  }
  ${(props) => props.left && `right: ${SWITCHER_WIDTH + 32}px`}
  ${(props) => props.right && `left: ${SWITCHER_WIDTH + 32}px`}
`;
